import { render, staticRenderFns } from "./TradeCategorization.vue?vue&type=template&id=71e0c3d5&"
import script from "./TradeCategorization.vue?vue&type=script&lang=js&"
export * from "./TradeCategorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports